import { apiBaseUrl, spevalApi } from 'yxt-biz-pc/packages/api';

let baseUrl = apiBaseUrl;

spevalApi.defaults.headers['x-yxt-product'] = 'sp';

// 获取评估方案配置详情
export const getEvalConfigs = (evaluationId) => {
  return spevalApi.get(`/mgr/evaluations/${evaluationId}/configs`);
};

// 导入评估关系
export const importEvalRelation = (data, targetId) => {
  return spevalApi.post(`/mgr/evaluationusers/import/${targetId}`, data);
};

// 根据导出的模板，导入第三方评估数据
export const thirdImportPerson = (data, evaluationId) => {
  return spevalApi.post(`/mgr/evaluationusers/${evaluationId}/resultimport`, data);
};

// 设置评估关系
export const postEvalRelation = (evaluationId, data) => {
  return spevalApi.post(`/mgr/evaluationusers/${evaluationId}/evalusers`, data);
};

// 获取评估跟踪-被评估人列表
export const getTrackPersons = (data, params) => {
  return spevalApi.post('/mgr/evaluationstrack/search', data, {
    params: params
  });
};

// 初始化选择的被评估人评估关系
export const addEvalTarget = (evaluationId, data) => {
  return spevalApi.post(`/mgr/evaluationusers/${evaluationId}/chosenusers`, data);
};

// 批量删除评估人员
export const deleteEvalusers = (evaluationId, data) => {
  return spevalApi.post(`/mgr/evaluationusers/${evaluationId}/deleteEvalusers`, data);
};

// 批量展示评估人员
export const postChooseUser = (data, params) => {
  return baseUrl.post('talent/mgr/traininguser/chooseuser', data, {
    params: params
  });
};

// 添加人员发布消息
export const postUsersNotify = (id, params) => {
  return spevalApi.post(`mgr/evaluationusers/${id}/usersNotify`, params);
};
